import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Logo } from '@/assets/logo';
import { Button } from '@/components/ui/button';
import { RegisterFormData } from '../types';
import { BasicInfo, FamilyInfo, AdditionalInfo } from '../components/form-sections';
import { useRegisterForm } from '../hooks/useRegisterForm';
import { RegisterSuccess } from '../components/RegisterSuccess';

export function RegisterPage() {
  const form = useForm<RegisterFormData>();
  const { onSubmit, isSubmitting, isSuccess, error } = useRegisterForm();

  if (isSuccess) {
    return <RegisterSuccess />;
  }

  return (
    <div className="min-h-screen bg-background py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-3xl shadow-sm p-6 md:p-8">
          <div className="flex flex-col items-center mb-8">
            <Logo className="h-24 mb-4" />
            <h1 className="text-2xl font-bold text-primary-dark text-center">
              طلب تسجيل في الخدمات الإلكترونية
            </h1>
            <p className="text-gray-500 text-center mt-2">
            ستتم اضافة البيانات من اجل الاستفادة من خدمات الموقع الالكتروني مثل اضافة مولود، من انت، الخ...
            </p>
          </div>

          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
            {/* Basic Information Section */}
            <BasicInfo form={form} />

            {/* Family Information Section */}
            <div className="border-t pt-8">
              <h3 className="text-lg font-semibold mb-6">معلومات العائلة</h3>
              <FamilyInfo form={form} />
            </div>

            {/* Additional Information Section */}
            <div className="border-t pt-8">
              <AdditionalInfo form={form} />
            </div>

            {error && (
              <p className="text-sm text-red-500 text-center">{error}</p>
            )}

            <Button 
              type="submit" 
              className="w-full"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'جاري إرسال الطلب...' : 'إرسال طلب التسجيل'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}